<script lang="ts">
    /*
    	DataWebField.svelte

        Link text (value) is clickable when read only 
    */

    import { onMount } from 'svelte';
    import { getFieldStyle } from '../../common/data-fields.js';
	import { setWarningAlert } from '../../stores/AlertsStore';

    // TCARE components

    // SMUI components
    import Tooltip, { Wrapper } from '@smui/tooltip';
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiClose, mdiChevronRightBox } from '@mdi/js';


    export let value;           // two way binding for the input changes
    export let propName;        // pass to onCopyValue for field to use
    export let label;           // the caption for the field
    export let isEditable;      // if false show as gray disabled
    export let isOrigDiff;      // if true show strike-thru
    export let isNewDiff;       // if true show yellow highlight
    export let onCopyValue;     // null or external setter function
    export let tooltip;         // if not blank will show in popover
    export let showDiffs;       // bypass the strike-through and highlighting

    const INVALID_URL_MSG = 'Invalid url: ';

    let originalValue;

    $: isDirty = originalValue !== value;
    $: fieldStyle = getFieldStyle(isEditable, isOrigDiff, isNewDiff, isDirty, showDiffs);
    $: isUnderlined = (value !== null) && (value !== '');

    // set originalValue one time only!
    onMount(() => {
        // console.log('');
        // console.log('DataWebField onMount');
        if (value && value.length < 3) {
            value = null;    // remove hyphens and other garbage
        }
        originalValue = value;                          // might be null - TODO: this clears when collapsed and expanded!
    });

    // TODO: must also reset the store, not just the field's value!
    // correction - because this is bound, the store is getting reset
    // 8/25 - MUST MAKE AN ARRAY FIELD TYPE (SIMILAR TO TAXONOMYFIELD)
    const resetValue = () => {
        value = originalValue;
    }

    const onInputClick = (e) => {
        openWebSite();
    }

    const _onCopyValue = () => {
        if (onCopyValue) onCopyValue(propName);              // call parent function
    }

    const sanitizeWeblink = (link: string): {link: string, ok: boolean} =>  {
        let sanitized = { link: "", ok: false};
        if(!link || link.length < 3) return sanitized;
        try {
            let url = new URL(link)
            sanitized.link = url.toString()
            sanitized.ok = true
            return sanitized
        } catch (error) {
           //continue
        }

        //check for scheme
        let matches = link.match(/^([a-z0-9]+):\/\//);
        if(matches === null || matches.length === 0){
            sanitized.link = "http://" + link
            sanitized.ok = true
            return sanitized
        }
        //more checks todo

        return sanitized
    }

    const openWebSite = () => {
        let sanitized = sanitizeWeblink(value)
        if(!sanitized.ok){ return}
        window.open(sanitized.link, "_blank") || window.location.replace(sanitized.link);

    }

</script>

<style>

    input {
        text-decoration: underline;
        cursor: pointer;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- contains a label, value and icons -->

<div class="data-field">
    <div class="label">{label}</div>

    <!-- only show tooltip if there is text there! -->
    <div class="value">
        <Wrapper>
            {#if isEditable}
                <input class="ellipsis" bind:value={value} style={fieldStyle}>
            {:else}
                <input class="ellipsis" bind:value={value} on:click={onInputClick} style={fieldStyle}>
            {/if}
            {#if tooltip && tooltip !== ''}
                <Tooltip xPos="start" yPos="above">{tooltip}</Tooltip>
            {/if}
        </Wrapper>
    </div>

    <div class="icons">
        <!-- the "copy to" icon - call parent's function -->
        {#if onCopyValue}
            {#if value && value !== ''}
                <div class="icon" on:click={_onCopyValue}>
                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiChevronRightBox} /></Icon>
                </div>
            {/if}
        {/if}

        <!-- the "X" icon - call local function -->
        {#if isEditable && isDirty}
            <div class="icon" on:click={() => resetValue()}>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiClose} /></Icon>
            </div>
        {/if}
    </div>
</div>
